import { BuilderConfig } from '../../types/Builder';

import BusinessHubSolutions, { Props } from './business-hub-solutions';

export const FullBleedConfig = {
    name: 'Business Hub Solutions',
    inputs: [
        {
            name: 'title',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'slides',
            type: 'list',
            required: true,
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                    required: true,
                },
                {
                    name: 'description',
                    type: 'richText',
                    required: false,
                },
                {
                    name: 'image',
                    type: 'file',
                    helperText: 'Use vertical images that are 2-3x resolution to ensure images render nicely on retina devices',
                    allowedFileTypes: ['jpg', 'jpeg', 'png'],
                    required: true,
                },
                {
                    name: 'imageRatio',
                    type: 'number',
                },
                {
                    name: 'imagePosition',
                    type: 'enum',
                    enum: ['center', 'bottom'],
                },
                {
                    name: 'imageBordered',
                    type: 'boolean',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<Props> = {
    component: BusinessHubSolutions,
    config: FullBleedConfig,
};

export default builderConfig;
